// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*  imported from Textarea-Control.module.scss  */
.Textarea-Control-module-Root_3aJ {
  position: relative;
  z-index: 2;
  /* рисуем поверх __box, чтобы сверху класть иконки */
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: inherit;
  margin: 0;
  font-family: var(--textarea-font-family);
  font-size: 0.875rem;
  line-height: 1.286;
  resize: none;
  vertical-align: middle;
  border: none;
  outline: 0;
  background: none;
  /* Лишние отступы у текста */
  /* stylelint-disable no-descending-specificity */
  /* Нативный крестик */
  /* Сбрасываем желтый background у инпутов при автозаполнении */ }
  .Textarea-Control-module-Root_3aJ::-webkit-scrollbar {
    width: 4px; }
  .Textarea-Control-module-Root_3aJ::-webkit-scrollbar-thumb {
    border-radius: 16px;
    background: #dee1eb; }
  .Textarea-Control-module-Root_3aJ::-ms-clear {
    display: none; }
  .Textarea-Control-module-Root_3aJ::-webkit-search-decoration {
    appearance: none; }
  .Textarea-Control-module-Root_3aJ::-webkit-search-cancel-button {
    display: none; }
  .Textarea-Control-module-Root_3aJ:-webkit-autofill {
    border-top-width: 2px;
    border-bottom-width: 2px;
    background-clip: content-box;
    box-shadow: inset 0 0 0 50px #fff;
    -webkit-text-fill-color: #000; }
  .Textarea-Control-module-Root_3aJ::placeholder {
    opacity: 1;
    /* В firefox полупрозрачный по умолчанию */ }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/InputText/Textarea/Textarea-Control.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB,iDAAiD;AACjD;EACE,kBAAkB;EAClB,UAAU;EACV,oDAAoD;EACpD,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,wCAAwC;EACxC,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,4BAA4B;EAC5B,gDAAgD;EAChD,qBAAqB;EACrB,8DAA8D,EAAE;EAChE;IACE,UAAU,EAAE;EACd;IACE,mBAAmB;IACnB,mBAAmB,EAAE;EACvB;IACE,aAAa,EAAE;EACjB;IACE,gBAAgB,EAAE;EACpB;IACE,aAAa,EAAE;EACjB;IACE,qBAAqB;IACrB,wBAAwB;IACxB,4BAA4B;IAC5B,iCAAiC;IACjC,6BAA6B,EAAE;EACjC;IACE,UAAU;IACV,0CAA0C,EAAE","sourcesContent":["@charset \"UTF-8\";\n/*  imported from Textarea-Control.module.scss  */\n.Textarea-Control-module-Root_3aJ {\n  position: relative;\n  z-index: 2;\n  /* рисуем поверх __box, чтобы сверху класть иконки */\n  box-sizing: border-box;\n  width: 100%;\n  height: 100%;\n  min-height: inherit;\n  margin: 0;\n  font-family: var(--textarea-font-family);\n  font-size: 0.875rem;\n  line-height: 1.286;\n  resize: none;\n  vertical-align: middle;\n  border: none;\n  outline: 0;\n  background: none;\n  /* Лишние отступы у текста */\n  /* stylelint-disable no-descending-specificity */\n  /* Нативный крестик */\n  /* Сбрасываем желтый background у инпутов при автозаполнении */ }\n  .Textarea-Control-module-Root_3aJ::-webkit-scrollbar {\n    width: 4px; }\n  .Textarea-Control-module-Root_3aJ::-webkit-scrollbar-thumb {\n    border-radius: 16px;\n    background: #dee1eb; }\n  .Textarea-Control-module-Root_3aJ::-ms-clear {\n    display: none; }\n  .Textarea-Control-module-Root_3aJ::-webkit-search-decoration {\n    appearance: none; }\n  .Textarea-Control-module-Root_3aJ::-webkit-search-cancel-button {\n    display: none; }\n  .Textarea-Control-module-Root_3aJ:-webkit-autofill {\n    border-top-width: 2px;\n    border-bottom-width: 2px;\n    background-clip: content-box;\n    box-shadow: inset 0 0 0 50px #fff;\n    -webkit-text-fill-color: #000; }\n  .Textarea-Control-module-Root_3aJ::placeholder {\n    opacity: 1;\n    /* В firefox полупрозрачный по умолчанию */ }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
